module.exports = __webpack_public_path__ + "img/fl.071b1d57.svg";